module.exports = "<div class=\"ic-block__header\">\r\n  <div class=\"ic-block__title\">{{name}}</div>\r\n  <div *ngIf=\"line\" class=\"ic-block__line\"></div>\r\n</div>\r\n<div class=\"ic-block__body\">\r\n  <ng-content></ng-content>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// G:/3csoft/client-final/src/app/layout/block/block.component.html
// module id = ../../../../../src/app/layout/block/block.component.html
// module chunks = main